export default __webpack_public_path__ + "static/media/chat1.3e904b84.svg";